export enum EField {
  CustomMessageBody = "customBody",
}

export interface IExtraData {
  customMessageBody?: string;
}
